import { render, staticRenderFns } from "./reg_date_question.vue?vue&type=template&id=0ebd009e&"
import script from "./reg_date_question.vue?vue&type=script&lang=js&"
export * from "./reg_date_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports